

















import Vue from 'vue';
import { VBtn } from 'vuetify/lib';
export default Vue.extend({
  components: {
    VBtn
  },
  props: {
    variant: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    color(): string {
      switch (this.variant) {
        case 'secondary':
          return 'dark';
        case 'tertiary':
          return 'dark';
        default:
          return this.$attrs['color'];
      }
    }
  }
});
